const v1 = 'v1/';
/**
 * @description
 * Contains api urls for all apis
 */
export const TableListApiUrls = {
  v1: {
    webinar_list: v1 + 'webinar-listing',
    archive_event: v1 + 'events/{id}/webinar-status',
    go_live: v1 + 'events/{id}/go-live-webrtc',
    end_old_go_live_new: v1 + 'events/{id}/end-live-webrtc',
    go_live_hoa: v1 + 'events/{id}/go-live-webrtc-hoa',
    questions: v1 + 'questions-chat-data',
    session_list: v1 + 'session-list/{id}',
    session_video_list: v1 + 'video-list/{id}',
    
    attendee_list: 'attendee-list',
    es_webinar_endpoint: 'webinar-list',
    es_offers_endpoint: 'offer-list',
    es_poll_endpoint: 'poll-list',
    event_details_analytics: v1 + 'events/{id}',
  },
};
